import ApiClient from "../helpers/ApiClient";

const listInvoices = (cnpj, params) =>
  ApiClient.apiClientDef.get(`/empresa/${cnpj}/invoices`, { params });

const postInvoice = (cnpj, data) =>
  ApiClient.apiClientDef.post(`/empresa/${cnpj}/invoices`, data);

const putInvoice = (cnpj, uid, data) =>
  ApiClient.apiClientDef.put(`/empresa/${cnpj}/invoices/${uid}`, data);

const enviarEmails = (cnpj, data) =>
  ApiClient.apiClientDef.post(`/empresa/${cnpj}/invoices/enviar_email/`, data);

const deleteInvoice = (cnpj, uid) =>
  ApiClient.apiClientDef.delete(`/empresa/${cnpj}/invoices/${uid}`);

const InvoiceApiClient = {
  listInvoices,
  postInvoice,
  putInvoice,
  enviarEmails,
  deleteInvoice,
};
export default InvoiceApiClient;
